import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	SignUpCheckExistence,
	SignUpCheckExistenceModel,
	SignUpCheckExistenceParams,
} from 'domain/usecases';

export class RemoteSignUpCheckExistence implements SignUpCheckExistence {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<SignUpCheckExistenceModel>,
	) {}

	async signUpCheckExistence({
		signal,
		...queryParams
	}: SignUpCheckExistenceParams): Promise<SignUpCheckExistenceModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params: queryParams,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
